import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal } from '@els/els-react--modal';
import { closeDialog } from '@Containers/Dialogs/DialogsActions';
import { typeOfSuggestModal } from '@Containers/Search/SearchBuilder/SuggestModal/SuggestModalConstants';
import SuggestModalFooter from './Components/SuggestModalFooter';
import SuggestModalHeader from './Components/SuggestModalHeader';
import SuggestModalContent from './Components/SuggestModalContent';
import './SuggestModal.scss';

function SuggestModal(props) {
  const { init } = props;
  const dispatch = useDispatch();
  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal
      onClose={() => {
        dispatch(
          closeDialog({
            id: typeOfSuggestModal,
          })
        );
      }}
      shouldCloseOnEscape
      className="react-dialogs-scrollable suggestModal"
      id="suggest-modal"
      shouldPreventClickOverlayToClose>
      <SuggestModalHeader {...props} />
      <SuggestModalContent {...props} />
      <SuggestModalFooter {...props} />
    </Modal>
  );
}

SuggestModal.propTypes = {
  init: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
};

export default SuggestModal;
